import { IBooking, ICustomer } from "app/app.types";
import {ISavedExtras, ISavedBookingSelectedOptions, IBookingLink} from "shared-types/index";

export interface IBookingOverview extends IProps, IServices {}

/** Common properties between IProps and IContainerProps */
export interface IBaseProps {

  /** Contains booking details */
  bookingInfo: IBooking;

  /** Contains urls linked to a booking */
  bookingLinks: IBookingLink[];

  /** Contains the total number of lines occupied by the booking options and extras */
  linesOccupiedByBookingOptions: number;
  linesOccupiedByUpsellOptions: number;

  venueId: number;
  currency: string;
}

/**
 * Properties passed in from angular instantiation.
 * This can include functions/handlers that simply call back to the Angular parent component
 * and do not need to modify app state (via a service).
 */
export interface IContainerProps extends IBaseProps {
  /** Contains customer details */
  customerInfo: ICustomer;
  handleEmailSmsNotification: (isNotificationEnabled: boolean) => void;
}

export interface IHandlers {
  handleEmailSmsNotification: (isNotificationEnabled: boolean) => void;
  isStatusNameInList?: (statusName: string, types: string[]) => boolean;
}

/**
 * Properties passed directly into the react component. If the container is responsible for fetching async data, via a
 * service, these may differ from IContainerProps.
 */
export interface IProps extends IBaseProps {
  customerId: string;
  paymentInfo: IPaymentOption;
  bookingNotesInfo: IBookingNotes;
  isManager: boolean;
  isSmsEnabled: boolean;
  isStandbyOrWaitlist: boolean;
}

/**
 * Contains payment details
 */
export interface IPaymentOption {
  /** Payment type i.e. NoPayment, Full Payment, Pre Authorisation, etc. */
  paymentType?: string;
  price?: string;
}

/** Contains booking notes */
export interface IBookingNotes {
  bookingNotes?: string;
  customerNotes?: string;
  managerNotes?: string;
}

export interface IServices {
}

/** Properties to be passed to the textfield */
export interface SummaryTextFieldProps {

  /** Label text for the textfield */
  labelText: string;

  /** Value for the textfield */
  value?: string;
}

/** Properties to be passed to BookingOption component */
export interface IBookingOptionProps {

  /** True, when the booking option contains extras */
  hasExtras: boolean;

  /** Can be a booking options or an extra */
  bookingOption: ISavedBookingSelectedOptions | ISavedExtras;

  /** Venue ISO currency code (e.g. 'AUD', 'USD') */
  currency?: string;
}

/** Properties to be passed to BookingOptions component */
export interface IBookingOptionsProps {

  /** Contains the total number of lines occupied by the booking options and extras */
  linesOccupiedByBookingOptions?: number;

  /** Contains the list of booking options including extras */
  bookingOptionList?: ISavedBookingSelectedOptions[];

  /** specifies if the BO passed is upsell item or not */
  isUpsell?:boolean
  currency?: string;
}

export const classPrefix = 'BookingOverview';
